import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/AboutPageComponents/HeroSection";
import VisionMissionSection from "../components/AboutPageComponents/VisionMissionSection";
import OurStorySection from "../components/AboutPageComponents/OurStorySection";
import OurTeamSection from "../components/AboutPageComponents/OurTeamSection";

export default function AboutUsPage() {
    return (
      <div className="relative w-full min-h-screen bg-[#E6F3CD] bg-opacity-80">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${images.LogoBackground})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            opacity: 0.2, 
            zIndex: -1, 
          }}
        ></div>
        <MainLayout>
          <HeroSection />
          <VisionMissionSection />
          <OurStorySection />
          <OurTeamSection />
        </MainLayout>
      </div>
    );
  }
  
